export default "__VITE_ASSET__9cd65f21__"